import { c as _c } from "react/compiler-runtime";
// Карточки раздела «Отзывы» (макет «Профиль»):
// — «Ждут отзыва»: белая r20 h149, фото 100×133 r16 (отступ 8), название 16,
//   бренд 14, «вариант» + значение 12, пять серых звёзд 24 — клик открывает
//   модалку отзыва;
// — «Мои отзывы»: дата 12 (48 %), фото 60×74 r16, звёзды 12 чёрные + вариант 14,
//   текст 14/18, лента медиа 40×53 r4 (видео с ▶), «Ответ:» продавца.
import { useState } from "react";
import { Link } from "react-router";
import type { BuyerPendingReview, BuyerReview } from "@/api";
import { StarIcon, Star32Icon } from "@/components/icons";
import { cn } from "@/lib/utils";
import { fmtLongDate, MediaStrip, ProductTile } from "./return-parts";
export function PendingReviewCard(t0) {
  const $ = _c(26);
  const {
    item,
    onRate
  } = t0;
  const [hover, setHover] = useState(0);
  const t1 = `/product/${item.productId}`;
  let t2;
  if ($[0] !== item.image) {
    t2 = <ProductTile src={item.image} />;
    $[0] = item.image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Link to={t1} className="shrink-0 rounded-[16px] outline-none focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">{t2}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `/product/${item.productId}`;
  let t5;
  if ($[5] !== item.name || $[6] !== t4) {
    t5 = <Link to={t4} className="truncate text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#1F1F1F] outline-none hover:text-[#FA5C2E]">{item.name}</Link>;
    $[5] = item.name;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.brand) {
    t6 = <p className="mt-1 truncate text-[14px] leading-[18px] text-[#1F1F1F]">{item.brand}</p>;
    $[8] = item.brand;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== item.size || $[11] !== item.variant) {
    t7 = item.variant ? <><p className="mt-1 text-[12px] leading-4 text-[#2E2E2E]">вариант</p><p className="mt-0.5 text-[12px] leading-4 text-[#2E2E2E]">{item.size || item.variant}</p></> : null;
    $[10] = item.size;
    $[11] = item.variant;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setHover(0);
    t9 = [1, 2, 3, 4, 5];
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== hover || $[16] !== onRate) {
    t10 = <div className="mt-auto flex gap-0.5" role="radiogroup" aria-label={"\u041E\u0446\u0435\u043D\u043A\u0430"} onMouseLeave={t8}>{t9.map(n => <button key={n} type="button" role="radio" aria-checked={false} aria-label={`${n} из 5`} onMouseEnter={() => setHover(n)} onClick={() => onRate(n)} className="rounded-[4px] outline-none focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><Star32Icon size={32} className={cn("transition-colors", n <= hover ? "text-[#FFB800]" : "text-[#1F1F1F]/12")} /></button>)}</div>;
    $[15] = hover;
    $[16] = onRate;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t11 = <div className="flex min-w-0 flex-1 flex-col">{t5}{t6}{t7}{t10}</div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t3) {
    t12 = <article className="flex gap-3 rounded-[20px] bg-white p-2">{t3}{t11}</article>;
    $[23] = t11;
    $[24] = t3;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}
export function MyReviewCard(t0) {
  const $ = _c(36);
  const {
    review
  } = t0;
  let t1;
  if ($[0] !== review.createdAt) {
    t1 = fmtLongDate(review.createdAt);
    $[0] = review.createdAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-[12px] leading-4 text-[#1F1F1F]/48">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== review.productId || $[5] !== review.productPhoto) {
    t3 = review.productId ? <Link to={`/product/${review.productId}`} className="shrink-0 rounded-[16px] outline-none focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><ProductTile src={review.productPhoto} w={60} h={74} className="bg-[#EDEDED]" /></Link> : <ProductTile src={review.productPhoto} w={60} h={74} className="bg-[#EDEDED]" />;
    $[4] = review.productId;
    $[5] = review.productPhoto;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `Оценка ${review.rating} из 5`;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [1, 2, 3, 4, 5];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== review.rating) {
    t6 = t5.map(n => <StarIcon key={n} size={12} className={n <= review.rating ? "text-[#1F1F1F]" : "text-[#1F1F1F]/12"} />);
    $[8] = review.rating;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <span className="flex gap-1.5" aria-label={t4}>{t6}</span>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== review.variant) {
    t8 = review.variant ? <span className="truncate text-[14px] leading-5 text-[#333]">{review.variant}</span> : null;
    $[13] = review.variant;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex items-center gap-1.5">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== review.text) {
    t10 = review.text ? <p className="mt-[14px] text-[14px] leading-[18px] whitespace-pre-line text-[#1F1F1F]">{review.text}</p> : null;
    $[18] = review.text;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== review.media) {
    t11 = review.media.length > 0 ? <MediaStrip items={review.media} className="mt-[14px]" /> : null;
    $[20] = review.media;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
    t12 = <div className="min-w-0 flex-1">{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t3) {
    t13 = <div className="mt-3 flex gap-3">{t3}{t12}</div>;
    $[26] = t12;
    $[27] = t3;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== review.sellerReply || $[30] !== review.sellerReplyAuthor) {
    t14 = review.sellerReply ? <div className="mt-[10px] pl-[98px] max-sm:pl-[72px]"><p className="text-[13px] leading-[18px] text-[#1F1F1F]/64">{review.sellerReplyAuthor ? `Ответ магазина «${review.sellerReplyAuthor}»:` : "\u041E\u0442\u0432\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430:"}</p><p className="mt-[6px] truncate text-[14px] leading-[18px] text-[#1F1F1F]" title={review.sellerReply}>{review.sellerReply}</p></div> : null;
    $[29] = review.sellerReply;
    $[30] = review.sellerReplyAuthor;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t2) {
    t15 = <article className="rounded-[20px] bg-white px-[10px] pt-[10px] pb-[14px]">{t2}{t13}{t14}</article>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t2;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}